import React from 'react';

import Modal from 'antd/lib/modal/Modal';
import cx from 'classnames';

import Icon from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';

import styles from './index.module.scss';

interface ISxTrialModalProps {
  header: React.ReactNode;
  leftSection: React.ReactNode;
  rightSection: React.ReactNode;
  rightBottomSection?: React.ReactNode;
  className?: string;
  onClose?: () => void;
  showCloseIcon?: boolean;
}

export class SxTrialModal extends React.PureComponent<ISxTrialModalProps> {
  private renderContent() {
    const { header, leftSection, rightSection, rightBottomSection, className, onClose, showCloseIcon = true } = this.props;
    const closeButton = showCloseIcon && (
      <Icon component={CrossSVG} className={styles.closeButton} onClick={onClose} />
    );
    return <article className={cx(styles.container, className)}>
      <header className={styles.header}>{header}{closeButton}</header>
      <section className={styles.content}>
        <div className={styles.leftSection}>{leftSection}</div>
        <div className={styles.rightSection}>
          <div className={styles.mainBlock}>{rightSection}</div>
          {rightBottomSection && <div className={styles.block}>{rightBottomSection}</div>}
        </div>
      </section>
    </article>;
  }

  render(): React.ReactElement {
    return (
      <Modal
        visible
        centered
        closable={false}
        className={styles.trialModal}
        footer={null}
        width={820}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}